<template>
  <div>
    <router-view />
  </div>
</template>

<script lang="ts">
export default {
  name: "SimulationIndividu",
}
</script>
